// @flow

import { createMuiTheme } from '@material-ui/core'

import palette from './palette'
// import typography from './typography'

const typography = {
  useNextVariants: true,
  fontFamily: '"Helvetica Neue", Roboto, Arial, sans-serif',
}

const defaultTheme = createMuiTheme({
  typography,
})

const paperStyles = {
  boxShadow: 'none',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: defaultTheme.palette.divider,
}

const theme = createMuiTheme({
  palette,
  typography,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
  shape: {
    borderRadius: '2px',
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: defaultTheme.shadows[0],
      },
    },
    MuiCard: {
      root: paperStyles,
    },
    MuiPaper: {
      elevation1: paperStyles,
    },
  },
})

export default theme
